import { UsersApiClient } from "@/Service/Api/V1/ApiClients/UsersApiClient";
import { CreateUserRequest } from "@/Stub/V1";
import { useMutation } from "@tanstack/react-query";
import { processValidationErrors } from "@/Util/Api/processValidationErrors";

export const useCreateUser = () => useMutation({
    mutationFn: async (data: CreateUserRequest) => {
        try {
            return await UsersApiClient.createUser(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});
